import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ContentSection() {
  const chapters = [{
    title: 'La oportunidad',
    description: 'Por qué esto funciona hoy y cómo posicionarte sin competir "a precio bajo".'
  }, {
    title: 'Construcción del negocio',
    description: 'Oferta, paquetes, qué vender primero y qué dejar para después.'
  }, {
    title: 'Costos y precios',
    description: 'Cómo calcular para ganar de verdad (sin miedo a cobrar).'
  }, {
    title: 'Operación',
    description: 'Producción, tiempos, pedidos y entregas sin caos.'
  }, {
    title: 'Marca y redes',
    description: 'Presencia simple que vende (IG/FB/WhatsApp).'
  }, {
    title: 'Plan de 30 días',
    description: 'Pasos semana a semana para generar movimiento real.'
  }];
  return <section className="py-20 md:py-28 bg-cream-ivory" data-id="element-79">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-81">
          <h2 className="text-4xl md:text-5xl font-extrabold text-coffee-dark mb-6 font-heading" data-id="element-82">
            Qué recibís al comprar
          </h2>
          <div className="w-24 h-1 bg-gold-matte mx-auto rounded-full mb-8" data-id="element-83"></div>

          <p className="text-xl text-text-body max-w-3xl mx-auto font-medium" data-id="element-84">
            <strong className="text-coffee-dark" data-id="element-85">
              Ebook: Desayunos Sorpresa Rentables*
            </strong>{' '}
            — guía práctica con introducción y 6 capítulos que cubren, en orden
            lógico:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-86">
          {chapters.map((chapter, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-md border-l-4 border-gold-matte hover:shadow-lg transition-shadow" data-id="element-87">
              <div className="flex items-start" data-id="element-88">
                <div className="bg-beige-sand text-coffee-dark font-bold rounded-full w-8 h-8 flex items-center justify-center mr-4 flex-shrink-0 mt-1" data-id="element-89">
                  {index + 1}
                </div>
                <div data-id="element-90">
                  <h3 className="text-xl font-bold text-coffee-dark mb-2" data-id="element-91">
                    {chapter.title}
                  </h3>
                  <p className="text-text-body" data-id="element-92">{chapter.description}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-beige-sand p-8 rounded-2xl border border-taupe-light/30 flex flex-col md:flex-row items-center justify-between gap-6 max-w-4xl mx-auto mb-12" data-id="element-93">
          <div className="flex items-center text-left" data-id="element-94">
            <SmartphoneIcon className="w-12 h-12 text-coffee-dark mr-6 flex-shrink-0" data-id="element-95" />
            <div data-id="element-96">
              <h4 className="text-xl font-bold text-coffee-dark mb-1" data-id="element-97">
                Formato 100% Digital
              </h4>
              <p className="text-text-body" data-id="element-98">
                Acceso digital inmediato. Podés leerlo en el celular y aplicarlo
                mientras avanzás.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center mt-4" data-id="element-99">
          <p className="text-lg text-red-600 font-bold mb-4 animate-pulse" data-id="element-100">
            ⏳ El precio actual no se mantiene por mucho tiempo
          </p>
          <CTAButton size="large" onClick={() => {
          const el = document.getElementById('offer-section');
          if (el) el.scrollIntoView({
            behavior: 'smooth'
          });else window.open('https://cocinaproductiva.com/cart/46911022334105:1', '_blank');
        }} data-id="element-101">
            QUIERO EMPEZAR HOY — VER OFERTA 🔥
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}